import React from "react"
import { MenuLink } from "@reach/menu-button"
import Card from "@convertkit/design/card"
import Button from "@convertkit/design/button"
import calloutMap from "app/navigation/utils/callout-map"

export default function UpgradeCallout({ userInfo }) {
  const [showCallout, calloutLink, calloutContent] = calloutMap(userInfo)

  return (
    <React.Fragment>
      {showCallout && (
        <MenuLink
          className="rounded-lg settings-note mb-2 p-0 group"
          style={{ padding: 0 }}
          href={calloutLink}
          data-jstrack={JSON.stringify({
            name: calloutContent["trackEvent"]
          })}
        >
          <Card className="bg-blue-50">
            <h2 className="pb-2 text-sm font-semibold group-hover:text-gray-800">
              {calloutContent["header"]}
            </h2>

            <div className="mb-5 text-gray-800 group-hover:text-gray-800 text-sm whitespace-pre-wrap">
              {calloutContent["text"]}
            </div>

            <Button color="light-blue">{calloutContent["buttonText"]}</Button>
          </Card>
        </MenuLink>
      )}
    </React.Fragment>
  )
}
